import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Device {
  id: number;
  uuid: string;
  width: number;
  height: number;
  descriptionName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/devices`;

  getAll(): Observable<Device[]> {
    return this.http.get<Device[]>(this.apiUrl);
  }
}
